var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useContext, useMemo, useState } from "react";
import ImportWizardNavigation from "./importWizardNavigation";
import { ImportContext } from "./importWizard";
import UploadFile from "@/components/dev/upload";
import logger from "js-logger";
import { useTranslation } from "react-i18next";
import { useGetFileImportToDownloadQuery, useGetFilePreviewImportQuery, useGetTempFileImportQuery, } from "@/store/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { Tooltip } from "react-tooltip";
/**
 * Composant pour l'import des enregistrements
 * @param param0
 * @returns
 */
export default function Step2(_a) {
    var _b, _c;
    var settings = _a.settings, goto = _a.goto;
    // Get ImportContext
    var importSettings = useContext(ImportContext);
    var _d = useState(true), hasError = _d[0], setHasError = _d[1];
    var _e = useState(""), error = _e[0], setError = _e[1];
    var _f = useState(null), file = _f[0], setFile = _f[1];
    var t = useTranslation(["Import", "Administration"]).t;
    function getLevel(step) {
        settings.step = step;
        (settings === null || settings === void 0 ? void 0 : settings.uploadFileName) !== false &&
            (settings === null || settings === void 0 ? void 0 : settings.file) !== null &&
            (settings === null || settings === void 0 ? void 0 : settings.file.content) &&
            (settings === null || settings === void 0 ? true : delete settings.file.content);
        goto("Step".concat(step));
    }
    var onEntriesDroped = useCallback(function (acceptedFiles) {
        try {
            acceptedFiles.forEach(function (fileEntry) {
                setError("");
                var fileType = ["application/csv", "text/csv"];
                if (fileEntry === null || fileEntry === void 0 ? void 0 : fileEntry.file) {
                    if (fileType.includes(fileEntry === null || fileEntry === void 0 ? void 0 : fileEntry.file.type)) {
                        setHasError(false);
                        setFile(fileEntry === null || fileEntry === void 0 ? void 0 : fileEntry.file);
                        settings.uploaded = true;
                        settings.file = fileEntry;
                        setFile64(settings.file.content);
                        setIsTemp(false);
                    }
                    else {
                        setError("File type" + fileType + " not alowed.");
                    }
                }
            });
        }
        catch (error) {
            logger.debug("Erreur lors de l'upload");
        }
    }, [settings]);
    var _g = useState(false), isFetch = _g[0], setIsFetch = _g[1];
    var example = useGetFileImportToDownloadQuery({
        params: {
            module: settings !== null && settings.selectedModule,
            action: "index",
            sample: true,
            all: true,
        },
    }, {
        skip: isFetch,
    }).data;
    var fileExample = (example && ((_b = example === null || example === void 0 ? void 0 : example.data) === null || _b === void 0 ? void 0 : _b.output)) || {};
    var fileName = (example && ((_c = example === null || example === void 0 ? void 0 : example.data) === null || _c === void 0 ? void 0 : _c.filename)) || {};
    function importTemplateExample(output, title) {
        setTimeout(function () {
            if (fileExample.length > 0) {
                var url = window.URL.createObjectURL(new Blob([output]));
                var link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", title + ".csv");
                document.body.appendChild(link);
                link.click();
            }
        }, 300);
    }
    var _h = useState(settings.importType), importType = _h[0], setImportType = _h[1];
    var setSelectedValue = function (value) {
        setImportType(value);
        settings.importType = value;
    };
    var _j = useState(true), isPreview = _j[0], setIsPreview = _j[1];
    var _k = useState(true), isTemp = _k[0], setIsTemp = _k[1];
    var _l = useState(), file64 = _l[0], setFile64 = _l[1];
    var _m = useState(), filePath = _m[0], setFilePath = _m[1];
    var tempfile = useGetTempFileImportQuery({
        params: {
            content: file64,
        },
        module: importSettings.selectedModule,
    }, {
        skip: isTemp,
    }).data;
    useMemo(function () {
        (tempfile === null || tempfile === void 0 ? void 0 : tempfile.data.uploadFileName) && setIsPreview(false);
        (tempfile === null || tempfile === void 0 ? void 0 : tempfile.data.uploadFileName) && setFilePath(tempfile === null || tempfile === void 0 ? void 0 : tempfile.data.uploadFileName);
    }, [tempfile]);
    var fileInfo = useGetFilePreviewImportQuery({
        params: {
            name: (settings === null || settings === void 0 ? void 0 : settings.file) != null && (settings === null || settings === void 0 ? void 0 : settings.file.name),
            content: (settings === null || settings === void 0 ? void 0 : settings.uploadFileName) ? settings === null || settings === void 0 ? void 0 : settings.uploadFileName : filePath,
            delimiter: ",",
            enclosure: "",
            source: "csv",
            hasHeader: "true",
        },
        moduleName: importSettings.selectedModule,
    }, {
        skip: isPreview,
    }).data;
    (fileInfo === null || fileInfo === void 0 ? void 0 : fileInfo.data) && initSettings(fileInfo.data);
    function initSettings(data) {
        var previews = data.previews || {};
        var hasHeader = data.hasHeader || false;
        var delimiter = data.delimiter || null;
        var delimiters = data.delimiters || {};
        var enclosure = data.enclosure || null;
        var enclosures = data.enclosures || {};
        var charsets = data.charsets || {};
        var charset = data.charset || null;
        var timeZone = data.timeZone || {};
        var timeZones = data.timeZones || {};
        var dateFormat = data.dateFormat || null;
        var dateFormats = data.dateFormats || {};
        var timeFormats = data.timeFormats || {};
        var timeFormat = data.timeFormat || null;
        var source = data.importSource || null;
        var uploadFileName = data.uploadFileName;
        settings.previews = previews;
        settings.delimiters = delimiters;
        settings.delimiter = delimiter;
        settings.enclosure = enclosure;
        settings.enclosures = enclosures;
        settings.charsets = charsets;
        settings.charset = charset;
        settings.timeZone = timeZone;
        settings.timeZones = timeZones;
        settings.dateFormats = dateFormats;
        settings.dateFormat = dateFormat;
        settings.timeFormats = timeFormats;
        settings.timeFormat = timeFormat;
        settings.hasHeader = hasHeader;
        settings.importType = importType;
        settings.source = source;
        settings.externalSource = "";
        settings.uploadFileName = uploadFileName;
    }
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "content" }, { children: [_jsxs("div", { children: [error && error.length > 0 && (_jsx("div", __assign({ className: "bg-[rgb(var(--color-red-400))] p-3 m-2 rounded-md " }, { children: _jsx("p", __assign({ className: "px-5 text-sm text-white font-medium" }, { children: error })) }))), _jsx("p", __assign({ className: "help" }, { children: "Select a file on your computer that contains the data that you would like to import, or download the template to get a head start on creating the import file." })), _jsxs("div", __assign({ className: "text-blue-500 mt-4" }, { children: [_jsx("span", __assign({ className: "cursor-pointer", onClick: function () {
                                        importTemplateExample(fileExample, fileName);
                                        setIsFetch(true);
                                    } }, { children: t("LBL_EXAMPLE_FILE") })), _jsx(FontAwesomeIcon, { className: "down-example text-gray-500 ml-2", icon: faCircleInfo }), _jsx(Tooltip, __assign({ anchorSelect: ".down-example", place: "top", variant: "info", style: { width: "250px" } }, { children: t("LBL_SAMPLE_URL_HELP") }))] }))] }), _jsxs("div", __assign({ className: "my-4" }, { children: [_jsx(UploadFile, { onEntriesDroped: onEntriesDroped, type: "file", labelUpload: t("LBL_BROWSE", { ns: "Administration" }) }), _jsx(FontAwesomeIcon, { className: "upload text-gray-500 ml-2", icon: faCircleInfo }), _jsx(Tooltip, __assign({ anchorSelect: ".upload", place: "top", variant: "info", style: { width: "250px" } }, { children: t("LBL_FILE_UPLOAD_WIDGET_HELP") })), _jsx(_Fragment, { children: (settings === null || settings === void 0 ? void 0 : settings.uploadFileName) && (settings === null || settings === void 0 ? void 0 : settings.uploadFileName) !== false && (_jsxs("div", __assign({ className: "flex border-2 rounded p-2 bg-emerald-200 flex-row justify-between w-[50%]" }, { children: [_jsx("span", __assign({ className: "text-ellipsis" }, { children: file !== null ? file.name : settings.file.name })), _jsxs("span", __assign({ className: "pl-1" }, { children: [Math.round(file !== null ? file.size / 1024 : settings.file.size / 1024), "KB"] }))] }))) })] })), _jsx("div", { children: _jsx("label", { children: "What would you like to do with the imported data?" }) }), _jsxs("div", { children: [_jsx("input", { value: "import", type: "radio", name: "import_type", checked: importType === "import", onChange: function () { return setSelectedValue("import"); } }), _jsx("label", __assign({ className: "ml-2" }, { children: t("LBL_IMPORT_BUTTON") })), _jsx(FontAwesomeIcon, { className: "import-type text-gray-500 ml-2", icon: faCircleInfo }), _jsx(Tooltip, __assign({ anchorSelect: ".import-type", place: "top", variant: "info", style: { width: "250px" } }, { children: t("LBL_CREATE_BUTTON_HELP") })), _jsx("br", {}), _jsx("input", { value: "update", type: "radio", name: "import_type", checked: importType === "update", onChange: function () { return setSelectedValue("update"); } }), _jsx("label", __assign({ className: "ml-2" }, { children: t("LBL_UPDATE_BUTTON") })), _jsx(FontAwesomeIcon, { className: "update-type text-gray-500 ml-2", icon: faCircleInfo }), _jsx(Tooltip, __assign({ anchorSelect: ".update-type", place: "top", variant: "info", style: { width: "250px" } }, { children: t("LBL_UPDATE_BUTTON_HELP") }))] }), _jsx(ImportWizardNavigation, { hasPrevious: true, hasNext: hasError !== true ||
                        (settings.file !== null &&
                            (settings === null || settings === void 0 ? void 0 : settings.file.content) !== undefined &&
                            (settings === null || settings === void 0 ? void 0 : settings.file.content.length) > 0) ||
                        (settings === null || settings === void 0 ? void 0 : settings.uploadFileName) !== false, hasImport: false, previousEnabled: false, nextEnabled: false, importEnabled: false, level: getLevel })] })) }));
}
